import React from 'react';

interface ErrorMessageProps {
  message: string;
  action?: () => void;
  actionLabel?: string;
  variant?: 'inline' | 'card';
}

export function ErrorMessage({
  message,
  action,
  actionLabel = 'Retry',
  variant = 'inline'
}: ErrorMessageProps) {
  if (variant === 'card') {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm">
        <div className="text-center">
          <p className="text-red-600 mb-4">{message}</p>
          {action && (
            <button
              onClick={action}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
            >
              {actionLabel}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <p className="text-red-600 text-sm">{message}</p>
      {action && (
        <button
          onClick={action}
          className="mt-2 text-sm text-red-700 hover:text-red-800"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
